<template>
	<HeroComponent :smallWidth="true">




		<template v-slot:hero-image>
			<div class="hero-image-container w-100 h-100 d-flex flex-row justify-center">
				<offer-banner-item-1 class="h-100 hero-image-item1"></offer-banner-item-1>
				<offer-banner-item-2 class="h-100"></offer-banner-item-2>
			</div>
		</template>

		<template v-slot:hero-title>
			All Offers
		</template>

		<template v-slot:hero-subtitle>
			<span>Discover offers and increase your earnings.</span>
			<br/>
			<span style="opacity: 0;">|</span>
			<!-- the above span is just for lifting the above text up on the UI 
				because its being centered by default on the screen and its kind of hiding behind 
				the controls, make making it look cluttered -->
		</template>




	</HeroComponent>
</template>


<script>

import OfferBannerItem1 from '@/icons/OfferBannerItem1.vue';
import OfferBannerItem2 from '@/icons/OfferBannerItem2.vue';
import HeroComponent from '@/components/Common/Hero-Component.vue';

export default {
	name: 'OfferBanner',
	components: {
		HeroComponent,
		OfferBannerItem1,
		OfferBannerItem2,
	},
}
</script>



<style scoped lang="scss">


.hero-image-container {
	position: relative;
	overflow: hidden;
	background: vars.get-map-value(vars.$banners, offer-page);
}

.hero-image-item1 {
	position: absolute;

	@media screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
		right: 0%;
	}

	@media screen and (max-width: vars.get-map-value(vars.$breakpoints, mobile)) {
		right: -30%;
	}

	@media screen and (min-width: 450px) and (max-width: 600px) {
		right: -15% !important;
	}
}
</style>
